import { Grid2 as Grid, Paper, Stack, Typography, Button } from '@mui/material'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'
import { analytics } from 'utils/analytics'

function Welcome() {
  const location = useLocation()
  const { logout, isAuthenticated } = useAuth0()

  useEffect(() => {
    // Make sure local storage is cleared
    localStorage.clear()

    // Send Google and Segment events
    if (typeof window !== 'undefined' && (window as any).gtag) {
      ;(window as any).gtag('event', 'conversion', {
        send_to: 'AW-17820199961/g94wCI6Msd0bEJnYqrFC',
      })
    }
    analytics.track('subscription_selection_completed')

    // make sure the user is logged out
    if (isAuthenticated) {
      logout({
        logoutParams: {
          returnTo: window.location.origin + location.pathname + location.search,
        },
      })
    }
  }, [location])

  return (
    <Grid
      container
      spacing={3}
      sx={{ minHeight: '100vh', paddingTop: { xs: '2vh', md: '5vh' }, px: { xs: 2, sm: 3, md: 0 } }}
    >
      <Grid size={{ xs: 0, md: 4 }}></Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <Paper
          variant="outlined"
          elevation={0}
          sx={{ padding: 1, borderRadius: 2, mx: 'auto', p: { xs: 2, sm: 3 }, textAlign: 'center' }}
        >
          <Stack sx={{ mb: { xs: -0.5, sm: 0.5 } }} spacing={{ xs: 1.5, sm: 2 }} alignItems="center">
            <img
              src="/PurcentLogo.svg"
              alt="Purcent Logo"
              style={{ maxWidth: '160px', width: '100%', margin: '0 auto' }}
            />
            <Typography variant="h3" sx={{ fontSize: { xs: '1.5rem', sm: '2rem', md: '1.25rem' } }}>
              Welcome to Purcent!
            </Typography>
            <Typography>
              You have been sent an email to verify your account. Once that has been completed you can log into your
              account at Purcent.
            </Typography>
            <Button
              variant="contained"
              color="primary"
              onClick={() => (window.location.href = 'https://app.purcent.com')}
              sx={{ mt: 2, width: { xs: '100%', sm: '50%', md: '33.33%' } }}
            >
              Login
            </Button>
          </Stack>
        </Paper>
      </Grid>
      <Grid size={{ xs: 0, md: 4 }}></Grid>
    </Grid>
  )
}

export default Welcome
